// eslint-disable-next-line import/prefer-default-export
export function getMeta(route) {
  if (!route) {
    return {};
  }

  return {
    ...getMeta(route?.matched?.[route?.matched?.length - 2]),
    ...(route?.meta || {}),
  };
}
